export const STATES = {
	waiting: 'En attente',
	shipping: 'Expédié'
};

export const RECIPIENT_EMAIL = 'vanessagegovinden@iotasystem.com';